module.exports = __webpack_public_path__ + "static/CSS3_Balloon-51077a45a1ad547b5bbf43478d6d8e64.png";